import {ITask} from "../../../../types/tasks.types";

const useDraftScale = (task: ITask, onChange: (val: number) => void) => {
    let imageScale = task.images?.[0]?.scale?.toString()
    if (imageScale == null) imageScale = '50'
    else if (Number(imageScale) < 1) imageScale = Math.round(Number(imageScale.toString()) * 100).toString()

    const handleChange = (val: string) => {
        if (Number.isNaN(parseInt(val))) return

        onChange(parseInt(val))
    }

    return { imageScale, handleChange }
}

export default useDraftScale